import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import useSendViewedEvent from '~/hooks/common/telemetry/useSendViewedEvent';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useResizeListener from '~/hooks/common/ui/useResizeListener';

export default function ShaqvanaData() {
  useDataDogRUM();
  useResizeListener(heliosSizes);
  useSendViewedEvent('ViewedPage - Shaqvana Landing');
  useTrackClickEvents();

  return null;
}
